import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UILibModule } from '../uilib/uilib.module';
import { TopicOverviewComponent } from './topic-overview.component';

const routes = [
  { path: ':topicId', component: TopicOverviewComponent },
  { path: ':topicId/:label/:name/:locationType', component: TopicOverviewComponent },
];

@NgModule({
  declarations: [TopicOverviewComponent],
  imports: [
    CommonModule,
    UILibModule,
    RouterModule.forChild(routes),
  ]
})
export class TopicOverviewModule { }
